module.exports = __webpack_public_path__ + "static/media/manifest.a81fc171.webapp";